import { GoalDto } from "../../common/request/goal.dto";

export interface GetGoalSummaryRequestParamsDto {
    goal: GoalDto;
}